import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavLink from '../NavLink';

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.primary.dark,
    textDecoration: 'none',
  },
}));

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.primary.dark,
    textDecoration: 'none',
  },
}));

export const StyledTitleAnchor = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  fontSize: 14,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
}));
